const STORAGE_UNAVAILABLE_URL = '/app/login/cookies-disabled';

module.exports = {
  STORAGE_UNAVAILABLE_URL,
};
